<div *ngIf="!showLoader && showMainArea" screen-size class="application-outlet" [class]="currentRouteName + '-page'">
    <cl-header></cl-header>
    <hr class="divider">
    <breadcrumb-navigation></breadcrumb-navigation>
    <responsive-navigation show-on="phone small-tablet" *ngIf="showResponsiveNavi"></responsive-navigation>
    <main>
        <favourites></favourites>
        <sub-navigation *ngIf="!showResponsiveNavi"></sub-navigation>
        <div class="content-area">
            <messages></messages>
            <router-outlet></router-outlet>
            <loader target=".content-area"></loader>
        </div>
        <upload-file-window></upload-file-window>
        <datapoint-editor-window></datapoint-editor-window>
        <release-notes-window></release-notes-window>
    </main>
    <hr class="divider">
    <cl-footer cookieLink="/CookieNotice"></cl-footer>
</div>
<div [hidden]="showLoader || !showAuthArea" screen-size #landingPage [class]="currentRouteName">
    <div class="landing-page">
        <release-notes-window></release-notes-window>
        <header>
            <a class="logo" href="#/Login" (click)="logoClicked($event)"></a>
            <drop-down [service]="language" test-id="language.input"></drop-down>
        </header>
        <div class="landing-page-content">
            <div class="topic">
                <h1 i18n="@@landingpage.topic.text" disable-empty format-text>Climatix IC -</h1>
                <h2 i18n="@@landingpage.subtopic.text" disable-empty format-text>Remote monitoring and intelligent diagnostics</h2>
            </div>
            <div class="content">
                <messages name="landingpage"></messages>
                <router-outlet name="loggedout"></router-outlet>
            </div>
            <global-notification-info></global-notification-info>
        </div>
        <div class="landingpage-extra-footer" disable-empty>
            <p i18n="@@landingpage.extra.footer.text" disable-empty format-text>null</p>
        </div>
        <cl-footer cookieLink="/CookieInfo"></cl-footer>
    </div>
</div>
<cookie-notification></cookie-notification>
<div id="dpi-tester"></div>
<router-outlet name="internalreleasenotes"></router-outlet>

